export default __webpack_public_path__ + "static/1-4da803f4b35af483e486825ff14f15d0.png";